import React from 'react';
import cn from '@/utils/cn';
import { iconVariant, TIconColor } from './iconVariant';
import { IconProps } from './types/IconInterface';

interface ChevronDoubleLeftProps extends IconProps {
  color?: TIconColor;
}

const ChevronDoubleLeft = ({
  size,
  variant,
  className,
  color = 'white'
}: ChevronDoubleLeftProps) => (
  <svg
    className={cn(iconVariant({ size, variant, iconColor: color, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.78033 3.21967C9.07322 3.51256 9.07322 3.98744 8.78033 4.28033L4.81066 8.25L8.78033 12.2197C9.07322 12.5126 9.07322 12.9874 8.78033 13.2803C8.48744 13.5732 8.01256 13.5732 7.71967 13.2803L3.21967 8.78033C2.92678 8.48744 2.92678 8.01256 3.21967 7.71967L7.71967 3.21967C8.01256 2.92678 8.48744 2.92678 8.78033 3.21967ZM13.2803 3.21967C13.5732 3.51256 13.5732 3.98744 13.2803 4.28033L9.31066 8.25L13.2803 12.2197C13.5732 12.5126 13.5732 12.9874 13.2803 13.2803C12.9874 13.5732 12.5126 13.5732 12.2197 13.2803L7.71967 8.78033C7.57322 8.63388 7.5 8.44194 7.5 8.25C7.5 8.05806 7.57322 7.86612 7.71967 7.71967L12.2197 3.21967C12.5126 2.92678 12.9874 2.92678 13.2803 3.21967Z"
      fill="currentColor"
    />
  </svg>
);

export default ChevronDoubleLeft;
